import * as React from 'react';
import blue_arrow from 'web/assets/images/blue_arrow.gif';
import lignt_blue_arrow from 'web/assets/images/lignt_blue_arrow.gif';
import mixed_Arrow from 'web/assets/images/mixed_Arrow.gif';
import styled from 'styled-components'
const Spinner = () => {
  let userType = localStorage.getItem('accountType')

  const getSrc = () => {
    switch (userType) {
      case "Seller":
        return lignt_blue_arrow;
        break;
      case "Buyer":
        return lignt_blue_arrow;
        break;
      case "Both":
        return mixed_Arrow;
        break;
      case "Reseller":
        return mixed_Arrow;
        break;
      case "Admin":
        return lignt_blue_arrow;
        break;
      default:
        return blue_arrow
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        position: 'fixed',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
      }}>
        <img src={getSrc()} alt='loader' style={{ width: '40px' }} />
    </div>
  );
}
export default Spinner;

const LdsGrid = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
 > div {
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #00b2fe;
  animation: lds-grid 1.2s linear infinite;

  

  :nth-child(1) {
    top: 8px;
    left: 8px;
    animation-delay: 0s;
  }
  :nth-child(2) {
    top: 8px;
    left: 32px;
    animation-delay: -0.4s;
  }
  :nth-child(3) {
    top: 8px;
    left: 56px;
    animation-delay: -0.8s;
  }
  :nth-child(4) {
    top: 32px;
    left: 8px;
    animation-delay: -0.4s;
  }
  :nth-child(5) {
    top: 32px;
    left: 32px;
    animation-delay: -0.8s;
  }
  :nth-child(6) {
    top: 32px;
    left: 56px;
    animation-delay: -1.2s;
  }
  :nth-child(7) {
    top: 56px;
    left: 8px;
    animation-delay: -0.8s;
  }
  :nth-child(8) {
    top: 56px;
    left: 32px;
    animation-delay: -1.2s;
  }
  :nth-child(9) {
    top: 56px;
    left: 56px;
    animation-delay: -1.6s;
  }
  @keyframes lds-grid {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
}
`

